var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtencion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5 84C67.2107 84 84 67.2107 84 46.5C84 25.7893 67.2107 9 46.5 9C25.7893 9 9 25.7893 9 46.5C9 67.2107 25.7893 84 46.5 84ZM46.5 93C72.1812 93 93 72.1812 93 46.5C93 20.8188 72.1812 0 46.5 0C20.8188 0 0 20.8188 0 46.5C0 72.1812 20.8188 93 46.5 93Z",
    fill: "#093C5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7666 22L50.6387 56.5557H42.4355L41.2734 22H51.7666ZM41 67.2539C41 65.7956 41.5013 64.5879 42.5039 63.6309C43.5293 62.651 44.8737 62.1611 46.5371 62.1611C48.2233 62.1611 49.5677 62.651 50.5703 63.6309C51.5729 64.5879 52.0742 65.7956 52.0742 67.2539C52.0742 68.6667 51.5729 69.863 50.5703 70.8428C49.5677 71.8226 48.2233 72.3125 46.5371 72.3125C44.8737 72.3125 43.5293 71.8226 42.5039 70.8428C41.5013 69.863 41 68.6667 41 67.2539Z",
    fill: "#093C5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtencion);
export default __webpack_public_path__ + "static/media/Atencion.bbcd8506621535632c0111bc764eccbf.svg";
export { ForwardRef as ReactComponent };